// removed by extract-text-webpack-plugin
module.exports = {"container":"G8ec19f"};